//Course Check Out Urls:
export const CartUrl = '/cart';
export const CartUcinetIdUrl = '/cart/ucinetid/';
export const CartProfileUpdateUrl = '/cart/profile-update/';
export const CartGradeOptionDiscountUrl = '/cart/grade-option-discount';
export const CartPrerequisiteUrl = '/cart/course-prerequisite-review';
export const CartFeeSummaryUrl = '/cart/fee-summary';
export const CartSummaryUrl = '/cart/cart-summary';
export const CartConfirmationUrl =  '/cart/enrollment-confirmation';

//OLLI Check Out Urls:
export const OlliUrl = '/olli';
export const OlliCoursesUrl = '/olli/olli-courses';
export const OlliCartUrl = '/olli/olli-cart';
export const OlliMembershipOptionUrl = '/olli/olli-membership-option';
export const OlliCartFeeSummaryUrl = '/olli/olli-fee-summary'; 
export const OlliCartSummaryUrl = '/olli/olli-cart-summary';
export const OlliCartConfirmationUrl = '/olli/olli-cart-confirmation';


//Basket Check Out Urls:
export const BasketCartUrl = '/basket-cart';
export const BasketCartFeeSummaryUrl = '/basket-cart/basket-payment';
export const BasketCartSummaryUrl = '/basket-cart/basket-summary';
export const BasketCartConfirmationUrl = '/basket-cart/basket-confirmation';
// Balance Payment
export const BalancePaymentUrl = '/basket-cart/basket-payment';


//Activities-cart  Urls:
export const ActivityCartListUrl = '/my-account/student-life-activities';
export const ActivityCartUrl = '/cart/activities-cart';
//export const BasketCartSummaryUrl = '/basket/basket-summary';

// My Account
export const MyAccountUrl = '/my-account';
export const DeclarationCandidacyUrl = '/my-account/my-certificates/declaration-of-candidacy';
export const OrderVerificationEnrollmentUrl = '/my-account/order-verification-of-enrollment';
export const OrderDuplicateCertificateUrl = '/my-account/my-certificates/order-your-duplicate-certificate';
export const ParalegalPartTimeUrl ='/my-account/my-certificates/declaration-of-candidacy/paralegal-part-time';
export const ParalegalPartTimeThankYouUrl = '/my-account/my-certificates/declaration-of-candidacy/paralegal-part-time/paralegal-part-time-thank-you';
export const MyDocumentsUrl = '/my-account/my-documents';
// Courses URL
export const CoursesUrl = '/courses';

// Login
export const LoginUrl = '/login';
export const ForgotPasswordUrl = '/forgot-password';
export const LookUpDCELoginUrl = '/lookup-dce-login-email';
export const CreateAccountUrl = '/create-new-account';



//Corporate Education
export const CorporateEducationUrl = '/corporate-education';

//International Programs
export const InternationalProgramsUrl = '/international-programs';

//Student Services
export const StudentServicesUrl = '/student-services';

//News
export const NewsUrl = '/news';

//Programs
export const ProgramsUrl = '/programs';

export const InstructorDetailsUrl = '/about/our-instructors/instructor-details';

export const APIDownError = 'An unknown error has occurred. Please try again later.'
export const CheckoutSummaryAgreementCheckBoxError = 'You must check off that you have read and agree to the UCI Division of Continuing Education policies before submitting changes to your schedule.';